/* tslint:disable */
/* eslint-disable */
/**
 * Haltian API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Create deployment group request object
 * @export
 * @interface CreateDeploymentGroupRequest
 */
export interface CreateDeploymentGroupRequest {
    /**
     * Group ID
     * @type {string}
     * @memberof CreateDeploymentGroupRequest
     */
    group_id: string;
    /**
     * Group description
     * @type {string}
     * @memberof CreateDeploymentGroupRequest
     */
    group_description: string;
}

export function CreateDeploymentGroupRequestFromJSON(json: any): CreateDeploymentGroupRequest {
    return CreateDeploymentGroupRequestFromJSONTyped(json, false);
}

export function CreateDeploymentGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeploymentGroupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group_id': json['group_id'],
        'group_description': json['group_description'],
    };
}

export function CreateDeploymentGroupRequestToJSON(value?: CreateDeploymentGroupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group_id': value.group_id,
        'group_description': value.group_description,
    };
}


